export enum AspectRatio {
  Aspect16x9 = "16:9",
  Aspect9x16 = "9:16",
  Aspect1x1 = "1:1",
  Aspect4x3 = "4:3",
}

export function isAspectRatio(value: unknown): value is AspectRatio {
  return (
    value === AspectRatio.Aspect16x9 ||
    value === AspectRatio.Aspect9x16 ||
    value === AspectRatio.Aspect1x1 ||
    value === AspectRatio.Aspect4x3
  );
}

/**
 * Parses a possibly-untyped aspect ratio value into a strongly typed option.
 * Fallback is 16:9.
 */
export function parseAspectRatio(value: unknown): AspectRatio {
  return isAspectRatio(value) ? value : AspectRatio.Aspect16x9;
}

